import { render } from "./Templater.vue?vue&type=template&id=a84a2536&scoped=true"
import script from "./Templater.vue?vue&type=script&lang=js"
export * from "./Templater.vue?vue&type=script&lang=js"

import "./Templater.vue?vue&type=style&index=0&id=a84a2536&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a84a2536"]])

export default __exports__